import React from "reactn";
import "./RequestInfo.css";
import { withRouter } from "react-router-dom";
import axios from "axios";
import BaseModal from "./baseModal/BaseModal";
import { GET_HTML } from "./baseModal/FieldTypes";

class WelcomePreviewModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      program: {}
    };
  }

  async componentDidMount() {
    const programId = this.props.programId || this.props.match.params.id;
    const ep = `${process.env.REACT_APP_API}/partners/welcome/${this.props.table}/${programId}`;

    try {
      this.setGlobal({ loading: true });
      const res = await axios.get(ep);

      this.setGlobal({
        loading: false,
        lastAPICall: res
      });
      this.setState({
        program: { ...res.data.data.program }
      });
    } catch (err) {
      this.setGlobal({ loading: false, lastAPICall: null });
    }
  }

  getPreview = () => {
    const { image, navigation, title, welcome } = this.props;
    const { program } = this.state;
    const backgroundImage = image || program.program_photo;

    return (
      <div>
        <div
          className="w-100"
          style={{
            minHeight: 240,
            backgroundImage: backgroundImage
              ? `url(${process.env.REACT_APP_DS_FILES_S3}/${backgroundImage})`
              : "none",
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundColor: "rgb(116 116 116 / 60%)",
            backgroundBlendMode: "multiply",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <div
            style={{
              color: "white",
              fontSize: "30px",
              fontWeight: "bold",
              fontFamily: "futura-pt, sans-serif"
            }}
          >
            {title || program.program_name}
          </div>
        </div>
        <div
          className="cont mb-5"
          style={{ position: "relative", marginTop: "-100px" }}
        >
          <div className="row">
            <div className="w-100">
              <div
                className="w-100 p-3 bg-white"
                style={{
                  borderRadius: "0px",
                  overflow: "hidden",
                  marginTop: 125
                }}
              >
                <h2
                  className="text-center"
                  style={{
                    color: "#2938be",
                    fontFamily: "futura-pt, sans-serif",
                    fontWeight: 700
                  }}
                >
                  Welcome Note
                </h2>
                <hr />
                <p
                  style={{
                    fontFamily: "futura-pt, sans-serif",
                    fontSize: "16px",
                    lineHeight: "20px"
                  }}
                  className="mt-3"
                >
                  {welcome || program.description}
                </p>
              </div>
              <div
                className="w-100 p-3 bg-white"
                style={{
                  borderRadius: "0px",
                  overflow: "hidden",
                  marginTop: 20
                }}
              >
                <h2
                  className="text-center"
                  style={{
                    color: "#2938be",
                    fontFamily: "futura-pt, sans-serif",
                    fontWeight: 700
                  }}
                >
                  Navigation Tips
                </h2>
                <hr />
                <div
                  style={{
                    fontFamily: "futura-pt, sans-serif",
                    fontSize: "16px",
                    lineHeight: "20px"
                  }}
                  className="mt-3"
                >
                  {navigation
                    ? navigation
                        .split("\n")
                        .map((line, index) => <p key={index}>{line}</p>)
                    : "Navigation Tips not provided!"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  getBaseModalProps = () => ({
    title: "Preview",
    fields: [
      {
        type: GET_HTML,
        data: {
          styles: { overflow: "scroll", height: "550px" },
          gethtml: this.getPreview
        }
      }
    ],
    buttons: undefined,
    handleClose: this.props.onClose,
    height: "742px",
    width: "800px"
  });

  render() {
    return <BaseModal {...this.getBaseModalProps()} />;
  }
}

export { WelcomePreviewModal };
export default withRouter(WelcomePreviewModal);
